import { ContactRole } from '~/models/ContactModel';
export const grantsPortalAccess = (isNative, role)=>isNative && role != null && role !== ContactRole.Reviewer;
